// export const SERVER_HOST = 'http://120.26.38.142:8888/mwellness-fitness'
// export const SERVER_HOST = 'http://120.26.38.142/mwellness-fitness/svr'
// export const SERVER_HOST = 'http://health.midea.com/mwellness-fitness/svr'
// export const SERVER_HOST = 'http://localhost:8081/api'
export const SERVER_HOST = '/admin'



// WEBPACK FOOTER //
// ./src/config/constants.js